import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { PlaceholderPage } from "Shared/Pages/PlaceholderPage";

export const HelpPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <PlaceholderPage
      title={t(Resources.Support.Title)}
      body={t(Resources.Support.Body)}
    />
  );
};
